
      export const versions = {
        commit: '5e3f49259dd1883839bd000d3d7c2cf79e348fae',
        branch: 'HEAD'
      };
